module.exports = __webpack_public_path__ + "static/media/carousel-3.d4b90dfa.jpg";